<template>
  <div v-if='isTranslation' class="probability column" :class="probabilityClass">
    {{ $t(probabilityText) }}
  </div>
  <div v-else class="probability column" :class="probabilityClass">
    {{ probabilityText }}
  </div>
</template>

<script>
export default {
  name: 'IssueProbability',
  props: {
    issue: {
      type: Object,
      required: true,
    },
    isTranslation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    probability() {
      return this.issue.probability || 'N/A';
    },
    probabilityClass() {
      return this.probability === 'N/A' ? '' : this.probability.toLowerCase();
    },
    probabilityText() {
      if (this.probability === 'N/A') {
        return 'informative';
      }
      return this.probability;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.probability {
  text-transform: capitalize;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(25);
  color: $severity-info;
  &.informative {
    color: $severity-info;
  }
  &.low {
    color: $severity-low;
  }
  &.medium {
    color: $severity-medium;
  }
  &.high {
    color: $severity-high;
  }
}
</style>
